import { render, staticRenderFns } from "./orderSd.vue?vue&type=template&id=50e35beb&scoped=true&"
import script from "./orderSd.vue?vue&type=script&lang=js&"
export * from "./orderSd.vue?vue&type=script&lang=js&"
import style0 from "./orderSd.vue?vue&type=style&index=0&id=50e35beb&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e35beb",
  null
  
)

export default component.exports